/**
 * @param {import('axios').AxiosResponse['data']} data
 * @param {string} key
 * @returns {{ items: object[], meta: import('@/types/api').PaginationMeta | null }}
 */
export function parseMasterCatalogResponse(data, key) {
  return {
    items: data.data[key] ?? [],
    meta: data.data.meta ?? null,
  }
}

/**
 * @typedef {import('@/types/api').PaginationMeta} PaginationMeta
 */

/**
 * @param {Record<string, unknown>} meta
 * @returns {PaginationMeta}
 */
export function defaultPaginationMeta(meta = {}) {
  return {
    current_page: Number(meta.current_page ?? 1),
    last_page: Number(meta.last_page ?? 1),
    per_page: Number(meta.per_page ?? 15),
    total: Number(meta.total ?? 0),
  }
}
